/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["ul[_ngcontent-%COMP%]{list-style-type:none;margin:0;padding:0;background-size:cover;background-position:50%}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{background:#fff;padding:2em;border-radius:4px;margin-bottom:7px;display:grid;grid-template-columns:auto;color:blue}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-weight:400;margin-left:20px}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .answersc[_ngcontent-%COMP%]{color:indigo}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{background-color:#000;max-width:750%}"];
export { styles as styles };

